import { fromJS } from 'immutable';
import { ROUTES } from '@shared/constants';
import { Types } from './actions';

export const initialState = fromJS({
  errors: {
    serverError: null,
  },
  sending: false,
  redirectToPage: null,
  codeDeliveryDetails: null,
});

const login = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case Types.SIGN_UP: {
      return state
        .setIn(['errors', 'serverError'], null)
        .set('sending', true)
        .set('redirectToPage', null)
        .set('codeDeliveryDetails', null);
    }
    case Types.SIGN_UP_FAIL: {
      return state
        .set('sending', false)
        .setIn(['errors', 'serverError'], fromJS(payload.error));
    }

    case Types.SIGN_UP_SUCCESS: {
      // For complete-signup recovery, we intentionally do NOT follow the legacy
      // redirect behavior (verify-email / sign-in). The saga will redirect.
      if (action.completeSignup) {
        return state.set('sending', false);
      }

      let nextState = state.set('sending', false);
      nextState = nextState.set('codeDeliveryDetails', fromJS(payload?.codeDeliveryDetails || null));
      if (action.available) {
        return nextState.setIn(
          ['redirectToPage'],
          fromJS(ROUTES.VERIFY_EMAIL_SENT)
        );
      }
      return nextState.setIn(['redirectToPage'], fromJS(ROUTES.SIGN_IN));
    }
    default: {
      return state;
    }
  }
};

export default login;
